import React from "react";

/**
 * Catalogue tile. Clicking anywhere opens the detail modal via `onOpen` —
 * the quote hand-off lives inside the modal so the card stays a single
 * predictable target.
 */
const ProductCard = ({ product, onOpen }) => {
  return (
    <button
      type="button"
      className="pcard"
      onClick={() => onOpen(product)}
      aria-label={`View details for ${product.name}`}>
      <span className="pcard__media">
        {product.image && (
          <img src={product.image} alt={product.name} loading="lazy" />
        )}
        <span className="pcard__formula">{product.formula}</span>
      </span>

      <span className="pcard__cat">{product.category}</span>
      <span className="pcard__name">{product.name}</span>
      <span className="pcard__grade">{product.grade}</span>

      <span className="pcard__meta">
        <span className="chip">{product.purity}</span>
        <span className="chip">{product.packaging}</span>
      </span>

      <span className="pcard__foot">
        <span className="pcard__price pcard__price--tbd">Price on request</span>
        <span className="pcard__cue" aria-hidden="true">→</span>
      </span>
    </button>
  );
};

export default ProductCard;
